/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Task_Combine_TitleInputs */

const en_pc_online_task_combine_title = /** @type {(inputs: Pc_Online_Task_Combine_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combine PDFs`)
};

const zh_pc_online_task_combine_title = /** @type {(inputs: Pc_Online_Task_Combine_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合并 PDF`)
};

/**
* | output |
* | --- |
* | "Combine PDFs" |
*
* @param {Pc_Online_Task_Combine_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_task_combine_title = /** @type {((inputs?: Pc_Online_Task_Combine_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Task_Combine_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_task_combine_title(inputs)
	return zh_pc_online_task_combine_title(inputs)
});
export { pc_online_task_combine_title as "pc.online.task.combine.title" }